import { useEffect, useMemo, useState, useCallback } from 'react';
import useQueues from './useQueues';
import * as y from 'yup';
import { throttle } from 'lodash';

import { ServiceUnifiedMonitoring } from 'services/ServiceUNIFIEDMONITORING';
import { io } from 'socket.io-client';

import { ServiceCRUDBACKEND } from 'services/ServiceCRUDBACKEND';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useSocketEvents, wrapSocketWithGlobalLoader } from './socket-utils';

const serviceBACKEND = new ServiceCRUDBACKEND();

const timeFormatRegex = /^(?:2[0-3]|[01]?[0-9]):[0-5][0-9]:[0-5][0-9]$/;

const HTTPResponseInitialDataSchema = y.object({
  agents: y
    .array()
    .of(
      y.object({
        login: y.string().required(),
        name: y.string().required(),
        averageChatNps: y.string().matches().required(),
        averageChatSatisfaction: y.string().matches().required(),
        averageVoiceNps: y.string().matches().required(),
        averageVoiceSatisfaction: y.string().matches().required(),
        countClosedChat: y.number().default(0).required(),
        countInAssignedChat: y.number().default(0).required(),
        countInAttendanceChat: y.number().default(0).required(),
        countProtocol: y.number().default(0).required(),
        // inPauseChat: y.boolean().required(),
        // inPausePhone: y.boolean().required(),
        // pauseIdChat: y.number().nullable().defined(),
        // queuesLoggedChat: y.array().of(y.number()).required(),
        // queuesLoggedPhone: y.array().of(y.number()).required(),
        extensionPhone: y.number().nullable(),
        tmaChat: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TMA Chat must be in "HH:mm:ss" format')
          .required(),
        tmaPhone: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TMA Phone must be in "HH:mm:ss" format')
          .required(),
        tmrAfterAssignChat: y
          .string()
          .default('00:00:00')
          .matches(
            timeFormatRegex,
            'TMR After Assign Chat must be in "HH:mm:ss" format'
          )
          .required(),
        tmrAfterAnswerChat: y
          .string()
          .default('00:00:00')
          .matches(
            timeFormatRegex,
            'TMR After Answer Chat must be in "HH:mm:ss" format'
          )
          .required(),
        tmeChat: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TME Chat must be in "HH:mm:ss" format')
          .required(),
        tmePhone: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TME Phone must be in "HH:mm:ss" format')
          .required(),
        totalActiveCalls: y.number().default(0).required(),
        totalReceivedCalls: y.number().default(0).required(),
        totalAnsweredCalls: y.number().default(0).required(),
        totalNotAnsweredCalls: y.number().default(0).required()
      })
    )
    .required(),
  queues: y
    .array()
    .of(
      y.object({
        agentsFreeChat: y.array().of(y.string()).required(),
        agentsFreePhone: y.array().of(y.string()).required(),
        agentsLoggedChat: y.array().of(y.string().required()).required(),
        agentsLoggedPhone: y.array().of(y.string()).required(),
        agentsInAttendancePhone: y.array().of(y.string()).required(),
        agentsPausedChat: y.array().of(y.string()).required(),
        agentsPausedPhone: y.array().of(y.string()).required(),
        averageChatNps: y.string().required(),
        averageChatSatisfaction: y.string().required(),
        averageVoiceNps: y.string().required(),
        averageVoiceSatisfaction: y.string().required(),
        countClosedChat: y.number().default(0).required(),
        countInAttendanceChat: y.number().default(0).required(),
        countInAssignedChat: y.number().default(0).required(),
        countWithoutAgentAndDistribution: y.number().default(0).required(),
        queueId: y.number().required(),
        tmaChat: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TMA Chat must be in "HH:mm:ss" format')
          .required(),
        tmaPhone: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TMA Phone must be in "HH:mm:ss" format')
          .required(),
        tmeChat: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TME Chat must be in "HH:mm:ss" format')
          .required(),
        tmePhone: y
          .string()
          .default('00:00:00')
          .matches(timeFormatRegex, 'TME Phone must be in "HH:mm:ss" format')
          .required(),
        tmrAfterAssignChat: y
          .string()
          .default('00:00:00')
          .matches(
            timeFormatRegex,
            'TMR After Assign Chat must be in "HH:mm:ss" format'
          )
          .required(),
        tmrAfterAnswerChat: y
          .string()
          .default('00:00:00')
          .matches(
            timeFormatRegex,
            'TMR After Answer Chat must be in "HH:mm:ss" format'
          )
          .required(),
        totalActiveCalls: y.number().required(),
        totalReceivedCalls: y.number().required(),
        totalAnsweredCalls: y.number().required(),
        totalNotAnsweredCalls: y.number().required()
      })
    )
    .required()
});

const SocketMonitoringUnifiedPartialDataSchema =
  HTTPResponseInitialDataSchema.deepPartial();

const MonitoringQueueTableDataSchema = y.object({
  name: y.string().required(),
  inAttendance: y
    .object({
      telephony: y.number().required(),
      chat: y.number().required()
    })
    .required(),
  inWaiting: y
    .object({
      telephony: y.number().default(0).required(),
      chat: y.number().default(0).required()
    })
    .required(),
  closed: y
    .object({
      telephony: y.number().default(0).required(),
      chat: y.number().default(0).required()
    })
    .required(),
  freeAgents: y
    .object({
      telephony: y.array(),
      chat: y.array()
    })
    .required(),
  pausedAgents: y
    .object({
      telephony: y.array(),
      chat: y.array()
    })
    .required(),
  averageAttendanceTime: y
    .object({
      telephony: y.string().default('00:00:00').required(),
      chat: y.string().default('00:00:00').required()
    })
    .required(),
  averageWaitingTime: y
    .object({
      telephony: y.string().default('00:00:00').required(),
      chat: y.string().default('00:00:00').required()
    })
    .required(),
  averageResponseTimeAfterAnswer: y.string().default('00:00:00').required(),
  averageResponseTimeAfterAssign: y.string().default('00:00:00').required()
});

const MonitoringAgentTableDataSchema = y.object({
  name: y.string().required(),
  login: y.string().required(),
  inPause: y
    .object({
      chat: y.boolean().required(),
      telephony: y.boolean().required()
    })
    .required(),
  closedChats: y.number().default(0).required(),
  totalActiveCalls: y.number().default(0).required(),
  totalReceivedCalls: y.number().default(0).required(),
  totalAnsweredCalls: y.number().default(0).required(),
  totalNotAnsweredCalls: y.number().default(0).required(),
  averageAttendanceTime: y
    .object({
      chat: y.string().default('00:00:00').required(),
      telephony: y.string().default('00:00:00').required()
    })
    .required(),
  averageWaitingTime: y
    .object({
      chat: y.string().default('00:00:00').required(),
      telephony: y.string().default('00:00:00').required()
    })
    .required(),
  averageResponseTimeAfterAnswer: y.string().default('00:00:00').required(),
  averageResponseTimeAfterAssign: y.string().default('00:00:00').required()
});

/** @type {Record<string, string>} */
let loginToAgentName = {};

/**
 * @param {Object} props
 * @param {import('./useQueues').Queue[]} props.allQueues
 * @param {WorkerResponseQueueData[]} props.workerResponseQueueData
 * @param {HTTPResponseInitialDataSchema} props.initialDataResponse
 * @param {SocketResponseTimeAverages[]} props.timeAverages
 * @returns {MonitoringQueueTableData[]}
 */
function buildMonitoringQueueTableData({
  allQueues = [],
  initialDataResponse = { agents: [], queues: [] }
}) {
  const {
    success: initialDataResponseSuccess,
    data: validatedInitialDataResponse
  } = HTTPResponseInitialDataSchema.safeValidateSync(initialDataResponse);

  if (!initialDataResponseSuccess) {
    return [];
  }
  const allowedQueueIds = new Set(allQueues.map((q) => q.id));

  const filteredQueues = validatedInitialDataResponse.queues.filter((queue) =>
    allowedQueueIds.has(queue.queueId)
  );

  const results = filteredQueues.map((queue) => {
    return {
      averageAttendanceTime: {
        chat: queue?.tmaChat,
        telephony: queue?.tmaPhone
      },
      averageResponseTimeAfterAssign: queue?.tmrAfterAssignChat,
      averageResponseTimeAfterAnswer: queue?.tmrAfterAnswerChat,
      averageWaitingTime: {
        chat: queue?.tmeChat,
        telephony: queue?.tmePhone
      },
      averageSatisfaction: {
        chat: queue?.averageChatSatisfaction,
        telephony: queue?.averageVoiceSatisfaction
      },
      averageNps: {
        chat: queue?.averageChatNps,
        telephony: queue?.averageVoiceNps
      },
      closedChats: queue?.countClosedChat ?? 0,
      telephonyCalls: {
        active: queue?.totalActiveCalls,
        received: queue?.totalReceivedCalls,
        answered: queue?.totalAnsweredCalls,
        notAnswered: queue?.totalNotAnsweredCalls
      },
      freeAgents: {
        chat: queue?.agentsFreeChat?.map?.((agt) => loginToAgentName?.[agt]),
        telephony: queue?.agentsFreePhone?.map?.(
          (agt) => loginToAgentName?.[agt]
        )
      },
      loggedAgents: {
        chat: queue?.agentsLoggedChat?.map?.((agt) => loginToAgentName?.[agt]),
        telephony: queue?.agentsLoggedPhone?.map?.(
          (agt) => loginToAgentName?.[agt]
        )
      },
      pausedAgents: {
        chat: queue?.agentsPausedChat?.map?.((agt) => loginToAgentName?.[agt]),
        telephony: queue?.agentsPausedPhone?.map?.(
          (agt) => loginToAgentName?.[agt]
        )
      },
      inAttendance: {
        chat: queue?.countInAttendanceChat ?? 0,
        telephony: queue?.agentsInAttendancePhone?.length ?? 0
      },
      inAssigned: queue.countInAssignedChat,
      inWaitInQueue: queue.countInWaitingQueue,
      inWaitWithoutQueue: queue.countWithoutAgentAndDistribution,
      name: queue.name
    };
  });

  const { success, data } = y
    .array()
    .of(MonitoringQueueTableDataSchema)
    .safeValidateSync(results);

  if (success) {
    const collator = new Intl.Collator(undefined, { sensitivity: 'base' });
    return data.sort((a, b) => collator.compare(a.name, b.name));
  }
  return [];
}

/**
 * @param {Object} props
 * @param {HTTPResponseInitialDataSchema} props.initialDataResponse
 * @param {SocketResponseTimeAverages[]} props.timeAverages
 * @returns {MonitoringAgentTableData[]}
 */
function buildMonitoringAgentTableData({
  initialDataResponse = { agents: [], queues: [] },
  allowedUsersLogins = []
}) {
  const {
    success: initialDataResponseSuccess,
    data: validatedInitialDataResponse
  } = HTTPResponseInitialDataSchema.safeValidateSync(initialDataResponse);

  if (!initialDataResponseSuccess) {
    console.error('Invalid input to buildMonitoringAgentTableData:', {
      initialDataResponseError: !initialDataResponseSuccess
    });
    return [];
  }

  const results = validatedInitialDataResponse.agents
    .filter((agt) => allowedUsersLogins.includes(agt.login))
    .map((agent) => {
      return {
        name: agent.name,
        login: agent.login,
        inPause: {
          chat: agent.inPauseChat,
          telephony: agent.inPausePhone
        },
        countProtocol: agent.countProtocol,
        closedChats: agent.countClosedChat,
        extensionPhone: agent.extensionPhone,
        inAssigned: agent.countInAssignedChat,
        inAttendance: agent.countInAttendanceChat,
        telephonyCalls: {
          active: agent.totalActiveCalls,
          received: agent.totalReceivedCalls,
          answered: agent.totalAnsweredCalls,
          notAnswered: agent.totalNotAnsweredCalls
        },
        averageAttendanceTime: {
          chat: agent?.tmaChat,
          telephony: agent?.tmaPhone
        },
        averageWaitingTime: {
          chat: agent?.tmeChat,
          telephony: agent?.tmePhone
        },
        averageResponseTimeAfterAnswer: agent?.tmrAfterAnswerChat,
        averageResponseTimeAfterAssign: agent?.tmrAfterAssignChat,
        averageSatisfaction: {
          chat: agent.averageChatSatisfaction,
          telephony: agent.averageVoiceSatisfaction
        },
        averageNps: {
          chat: agent.averageChatNps,
          telephony: agent.averageVoiceNps
        }
      };
    });

  const { success, data } = y
    .array()
    .of(MonitoringAgentTableDataSchema)
    .safeValidateSync(results);

  if (success) {
    const collator = new Intl.Collator(undefined, { sensitivity: 'base' });
    return data.sort((a, b) => collator.compare(a.name, b.name));
  }
  return [];
}

export function useMonitoringUnified() {
  /**
   * Recebe os dados inicias vindos do socket socket InitialData. Esses dados serão, posteriormente, mutados por outros sockets menores de update.
   * @type {[HTTPResponseInitialDataSchema, React.Dispatch<React.SetStateAction<HTTPResponseInitialDataSchema>>]}
   */
  const [initialDataResponse, setInitialDataResponse] = useState({
    agents: [],
    queues: []
  });

  /** Armazena as informações de todas as filas */
  const { response: allQueues } = useQueues({
    shouldUseOnlyAllowedUserQueues: true
  });

  /**
   * Logins dos usuários que o `login` tem acesso
   * @type {[string, React.Dispatch<React.SetStateAction<string>>]}
   */
  const [allowedUsersLogins, setAllowedUsersLogins] = useState([]);

  const socketMonitoringUnified = useMemo(() => {
    return wrapSocketWithGlobalLoader(
      io(process.env.REACT_APP_PROXY_URL, {
        path: '/flex-unified-monitoring-socket',
        transports: ['websocket'],
        upgrade: false,
        query: { token: localStorage.getItem('token') },
        reconnection: true,
        reconnectionDelay: 1000
      })
    );
  }, []);

  const monitoringQueueTableData = useMemo(() => {
    return buildMonitoringQueueTableData({
      allQueues,
      initialDataResponse
    });
  }, [allQueues, initialDataResponse]);

  const monitoringAgentTableData = useMemo(() => {
    return buildMonitoringAgentTableData({
      initialDataResponse,
      allowedUsersLogins
    });
  }, [initialDataResponse]);

  useEffect(() => {
    const login = localStorage.getItem('login');

    serviceBACKEND.getAllowedUsersByLogin(login).then((res) => {
      const loginsRaw = res?.data;

      const {
        data: allowedLogins,
        success,
        error
      } = yup
        .array(yup.string())
        .required(
          `Não foi possível buscar os atendentes que ${login} possui acesso`
        )
        .min(1, `O login ${login} não possui acesso a nenhum atendente`)
        .safeValidateSync(loginsRaw);

      if (!success)
        return toast.warn(error?.message ?? `Erro ao buscar atendentes`);

      setAllowedUsersLogins(allowedLogins);
    });
  }, []);

  useEffect(() => {
    loginToAgentName = Object.fromEntries(
      initialDataResponse?.agents?.map?.((agt) => [agt?.login, agt?.name]) ?? []
    );
  }, [initialDataResponse?.agents?.map?.((agt) => agt.login)?.join()]);

  useEffect(() => {
    const service = new ServiceUnifiedMonitoring();

    service
      .getInitialData()
      .then((rawInitialData) => {
        const { data: initialData, success } =
          HTTPResponseInitialDataSchema.safeValidateSync(
            rawInitialData?.data?.data
          );

        if (!success) return;

        setInitialDataResponse(initialData);
      })
      .catch(console.log);
  }, []);

  const throttledUpdateUnifiedMonitoringPartialData = useCallback(
    throttle((update) => {
      const {
        success,
        data: { agents: updateAgents, queues: updateQueues }
      } = SocketMonitoringUnifiedPartialDataSchema.safeValidateSync(update, {
        strict: true,
        stripUnknown: true,
        abortEarly: false
      });

      if (!success) return;

      // Evita rerenders caso não haja atualizações
      if (!updateQueues.length && !updateAgents.length) return;

      setInitialDataResponse(({ agents: prevAgents, queues: prevQueues }) => {
        const newAgents = prevAgents.map((agt) => {
          const updateAgentIndex = updateAgents.findIndex(
            (a) => a.login === agt.login
          );

          if (updateAgentIndex < 0) return agt;

          return {
            ...agt,
            ...updateAgents[updateAgentIndex]
          };
        });

        const newQueues = prevQueues.map((queue) => {
          const updateQueueIndex = updateQueues.findIndex(
            (q) =>
              (q.queueId === queue.queueId || q.name === queue.name) &&
              queue.name
          );

          if (updateQueueIndex < 0) return queue;

          return {
            ...queue,
            ...updateQueues[updateQueueIndex]
          };
        });

        return {
          agents: newAgents,
          queues: newQueues
        };
      });
    }, 100),
    []
  );

  useSocketEvents(socketMonitoringUnified, {
    UPDATE_UNIFIED_MONITORING_PARTIAL_DATA:
      throttledUpdateUnifiedMonitoringPartialData,
    UPDATE_UNIFIED_MONITORING_OVERRIDE_INITIAL_DATA: (updateData) => {
      const { success, data } =
        HTTPResponseInitialDataSchema.safeValidateSync(updateData);

      if (!success) return;

      setInitialDataResponse(data);
    }
  });

  return {
    monitoringQueueTableData,
    monitoringAgentTableData
  };
}
